import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerrh';
import Cargos from '../../../components/rh/cargos/listar';


function ListCargosScreen () {
    return (
        <Fragment>
            <Head titulo="Listagem de Cargos | Consórcio LVF" />
            <Header />
            <Cargos />
            <Footer />
        </Fragment>
    );
}

export default ListCargosScreen;